module.exports = __webpack_public_path__ + "static/media/indiamartlogo.e1eb37d8.png";